import React from "react";
import { CustomerSignin as Form } from "../modules/Security";
import { Helmet } from "react-helmet";
import styled from "@emotion/styled";

const Container = styled.div`
  display: flex;
  flex: 1;
  min-height: 100%;
  align-items: center;
  justify-content: center;
  background-color: #000000;
  position: relative;

  @media (max-width: 768px) {
    align-items: center;
    padding: 2rem 0;
  }
`;

const Background = styled.div`
  background: linear-gradient(
      180deg,
      rgba(31, 32, 33, 0) 39.41%,
      rgba(31, 32, 33, 0.64) 100%
    ),
    url("https://cdn.cardcash.com/website/premier/new-sign-in-bj.jpeg");
  background-size: cover;
  position: absolute;
  top: 0;
  opacity: 0.2;
  width: 100%;
  height: 100%;
`;

const CustomerSignin = () => {
  return (
    <Container>
      <Helmet>
        <title>Sign In</title>
      </Helmet>
      <Background />
      <Form />
    </Container>
  );
};

CustomerSignin.propTypes = {};

export default CustomerSignin;
